const countriesMap = {
  AF: { name: 'Afghanistan', code: 'AF', callingCode: '+93' },
  AX: { name: 'Åland Islands', code: 'AX', callingCode: '+358 18' },
  AL: { name: 'Albania', code: 'AL', callingCode: '+355' },
  DZ: { name: 'Algeria', code: 'DZ', callingCode: '+213' },
  AS: { name: 'American Samoa', code: 'AS', callingCode: '+1 684' },
  AD: { name: 'Andorra', code: 'AD', callingCode: '+376' },
  AO: { name: 'Angola', code: 'AO', callingCode: '+244' },
  AI: { name: 'Anguilla', code: 'AI', callingCode: '+1 264' },
  AQ: { name: 'Antarctica', code: 'AQ', callingCode: '+672 1' },
  AG: { name: 'Antigua and Barbuda', code: 'AG', callingCode: '+1 268' },
  AR: { name: 'Argentina', code: 'AR', callingCode: '+54' },
  AM: { name: 'Armenia', code: 'AM', callingCode: '+374' },
  AW: { name: 'Aruba', code: 'AW', callingCode: '+297' },
  AC: { name: 'Ascension Island', code: 'AC', callingCode: '+247' },
  AU: { name: 'Australia', code: 'AU', callingCode: '+61' },
  AT: { name: 'Austria', code: 'AT', callingCode: '+43' },
  AZ: { name: 'Azerbaijan', code: 'AZ', callingCode: '+994' },
  BS: { name: 'Bahamas', code: 'BS', callingCode: '+1 242' },
  BH: { name: 'Bahrain', code: 'BH', callingCode: '+973' },
  BD: { name: 'Bangladesh', code: 'BD', callingCode: '+880' },
  BB: { name: 'Barbados', code: 'BB', callingCode: '+1 246' },
  BY: { name: 'Belarus', code: 'BY', callingCode: '+375' },
  BE: { name: 'Belgium', code: 'BE', callingCode: '+32' },
  BZ: { name: 'Belize', code: 'BZ', callingCode: '+501' },
  BJ: { name: 'Benin', code: 'BJ', callingCode: '+229' },
  BM: { name: 'Bermuda', code: 'BM', callingCode: '+1 441' },
  BT: { name: 'Bhutan', code: 'BT', callingCode: '+975' },
  BO: { name: 'Bolivia', code: 'BO', callingCode: '+591' },
  BQ: { name: 'Bonaire, St. Eustatius and Saba', code: 'BQ', callingCode: '+599' },
  BA: { name: 'Bosnia and Herzegovina', code: 'BA', callingCode: '+387' },
  BW: { name: 'Botswana', code: 'BW', callingCode: '+267' },
  BV: { name: 'Bouvet Island', code: 'BV', callingCode: '' },
  BR: { name: 'Brazil', code: 'BR', callingCode: '+55' },
  IO: { name: 'British Indian Ocean Territory', code: 'IO', callingCode: '+246' },
  BN: { name: 'Brunei Darussalam', code: 'BN', callingCode: '+673' },
  BG: { name: 'Bulgaria', code: 'BG', callingCode: '+359' },
  BF: { name: 'Burkina Faso', code: 'BF', callingCode: '+226' },
  BI: { name: 'Burundi', code: 'BI', callingCode: '+257' },
  KH: { name: 'Cambodia', code: 'KH', callingCode: '+855' },
  CM: { name: 'Cameroon', code: 'CM', callingCode: '+237' },
  CA: { name: 'Canada', code: 'CA', callingCode: '+1' },
  CV: { name: 'Cape Verde', code: 'CV', callingCode: '+238' },
  KY: { name: 'Cayman Islands', code: 'KY', callingCode: '+1 345' },
  CF: { name: 'Central African Republic', code: 'CF', callingCode: '+236' },
  TD: { name: 'Chad', code: 'TD', callingCode: '+235' },
  CL: { name: 'Chile', code: 'CL', callingCode: '+56' },
  CN: { name: 'China', code: 'CN', callingCode: '+86' },
  CX: { name: 'Christmas Island', code: 'CX', callingCode: '+61 89164' },
  CC: { name: 'Cocos (Keeling) Islands', code: 'CC', callingCode: '+61 89162' },
  CO: { name: 'Colombia', code: 'CO', callingCode: '+57' },
  KM: { name: 'Comoros', code: 'KM', callingCode: '+269' },
  CG: { name: 'Congo', code: 'CG', callingCode: '+242' },
  CD: { name: 'Congo, The Democratic Republic of the', code: 'CD', callingCode: '+243' },
  CK: { name: 'Cook Islands', code: 'CK', callingCode: '+682' },
  CR: { name: 'Costa Rica', code: 'CR', callingCode: '+506' },
  CI: { name: "Cote D'Ivoire", code: 'CI', callingCode: '+225' },
  HR: { name: 'Croatia', code: 'HR', callingCode: '+385' },
  CU: { name: 'Cuba', code: 'CU', callingCode: '+53' },
  CW: { name: 'Curacao', code: 'CW', callingCode: '+599' },
  CY: { name: 'Cyprus', code: 'CY', callingCode: '+357' },
  CZ: { name: 'Czech Republic', code: 'CZ', callingCode: '+420' },
  DK: { name: 'Denmark', code: 'DK', callingCode: '+45' },
  DG: { name: 'Diego Garcia', code: 'DG', callingCode: '+246' },
  DJ: { name: 'Djibouti', code: 'DJ', callingCode: '+253' },
  DM: { name: 'Dominica', code: 'DM', callingCode: '+1 767' },
  DO: { name: 'Dominican Republic', code: 'DO', callingCode: '+18' },
  TL: { name: 'East Timor', code: 'TL', callingCode: '+670' },
  EC: { name: 'Ecuador', code: 'EC', callingCode: '+593' },
  EG: { name: 'Egypt', code: 'EG', callingCode: '+20' },
  SV: { name: 'El Salvador', code: 'SV', callingCode: '+503' },
  GQ: { name: 'Equatorial Guinea', code: 'GQ', callingCode: '+240' },
  ER: { name: 'Eritrea', code: 'ER', callingCode: '+291' },
  EE: { name: 'Estonia', code: 'EE', callingCode: '+372' },
  ET: { name: 'Ethiopia', code: 'ET', callingCode: '+251' },
  FK: { name: 'Falkland Islands', code: 'FK', callingCode: '+500' },
  FO: { name: 'Faroe Islands', code: 'FO', callingCode: '+298' },
  FJ: { name: 'Fiji', code: 'FJ', callingCode: '+679' },
  FI: { name: 'Finland', code: 'FI', callingCode: '+358' },
  FR: { name: 'France', code: 'FR', callingCode: '+33' },
  GF: { name: 'French Guiana', code: 'GF', callingCode: '+594' },
  PF: { name: 'French Polynesia', code: 'PF', callingCode: '+689' },
  GA: { name: 'Gabon', code: 'GA', callingCode: '+241' },
  GM: { name: 'Gambia', code: 'GM', callingCode: '+220' },
  GE: { name: 'Georgia', code: 'GE', callingCode: '+995' },
  DE: { name: 'Germany', code: 'DE', callingCode: '+49' },
  GH: { name: 'Ghana', code: 'GH', callingCode: '+233' },
  GI: { name: 'Gibraltar', code: 'GI', callingCode: '+350' },
  GR: { name: 'Greece', code: 'GR', callingCode: '+30' },
  GL: { name: 'Greenland', code: 'GL', callingCode: '+299' },
  GD: { name: 'Grenada', code: 'GD', callingCode: '+1 473' },
  GP: { name: 'Guadeloupe', code: 'GP', callingCode: '+590' },
  GU: { name: 'Guam', code: 'GU', callingCode: '+1 671' },
  GT: { name: 'Guatemala', code: 'GT', callingCode: '+502' },
  GG: { name: 'Guernsey', code: 'GG', callingCode: '+44' },
  GN: { name: 'Guinea', code: 'GN', callingCode: '+224' },
  GW: { name: 'Guinea-Bissau', code: 'GW', callingCode: '+245' },
  GY: { name: 'Guyana', code: 'GY', callingCode: '+592' },
  HT: { name: 'Haiti', code: 'HT', callingCode: '+509' },
  HM: { name: 'Heard Island and McDonald Islands', code: 'HM', callingCode: '+509' },
  HN: { name: 'Honduras', code: 'HN', callingCode: '+504' },
  HK: { name: 'Hong Kong', code: 'HK', callingCode: '+852' },
  HU: { name: 'Hungary', code: 'HU', callingCode: '+36' },
  IS: { name: 'Iceland', code: 'IS', callingCode: '+354' },
  IN: { name: 'India', code: 'IN', callingCode: '+91' },
  ID: { name: 'Indonesia', code: 'ID', callingCode: '+62' },
  IR: { name: 'Iran', code: 'IR', callingCode: '+98' },
  IQ: { name: 'Iraq', code: 'IQ', callingCode: '+964' },
  IE: { name: 'Ireland', code: 'IE', callingCode: '+353' },
  IM: { name: 'Isle of Man', code: 'IM', callingCode: '+44' },
  IL: { name: 'Israel', code: 'IL', callingCode: '+972' },
  IT: { name: 'Italy', code: 'IT', callingCode: '+39' },
  JM: { name: 'Jamaica', code: 'JM', callingCode: '+1 876' },
  JP: { name: 'Japan', code: 'JP', callingCode: '+81' },
  JE: { name: 'Jersey', code: 'JE', callingCode: '+44 1534' },
  JO: { name: 'Jordan', code: 'JO', callingCode: '+962' },
  KZ: { name: 'Kazakhstan', code: 'KZ', callingCode: '+7' },
  KE: { name: 'Kenya', code: 'KE', callingCode: '+254' },
  KI: { name: 'Kiribati', code: 'KI', callingCode: '+686' },
  XK: { name: 'Kosovo', code: 'XK', callingCode: '+383' },
  KW: { name: 'Kuwait', code: 'KW', callingCode: '+965' },
  KG: { name: 'Kyrgyzstan', code: 'KG', callingCode: '+996' },
  LA: { name: 'Laos', code: 'LA', callingCode: '+856' },
  LV: { name: 'Latvia', code: 'LV', callingCode: '+371' },
  LB: { name: 'Lebanon', code: 'LB', callingCode: '+961' },
  LS: { name: 'Lesotho', code: 'LS', callingCode: '+266' },
  LR: { name: 'Liberia', code: 'LR', callingCode: '+231' },
  LY: { name: 'Libya', code: 'LY', callingCode: '+218' },
  LI: { name: 'Liechtenstein', code: 'LI', callingCode: '+423' },
  LT: { name: 'Lithuania', code: 'LT', callingCode: '+370' },
  LU: { name: 'Luxembourg', code: 'LU', callingCode: '+352' },
  MO: { name: 'Macau', code: 'MO', callingCode: '+853' },
  MK: { name: 'Macedonia', code: 'MK', callingCode: '+389' },
  MG: { name: 'Madagascar', code: 'MG', callingCode: '+261' },
  MW: { name: 'Malawi', code: 'MW', callingCode: '+265' },
  MY: { name: 'Malaysia', code: 'MY', callingCode: '+60' },
  MV: { name: 'Maldives', code: 'MV', callingCode: '+960' },
  ML: { name: 'Mali', code: 'ML', callingCode: '+223' },
  MT: { name: 'Malta', code: 'MT', callingCode: '+356' },
  MH: { name: 'Marshall Islands', code: 'MH', callingCode: '+692' },
  MQ: { name: 'Martinique', code: 'MQ', callingCode: '+596' },
  MR: { name: 'Mauritania', code: 'MR', callingCode: '+222' },
  MU: { name: 'Mauritius', code: 'MU', callingCode: '+230' },
  YT: { name: 'Mayotte', code: 'YT', callingCode: '+262' },
  MX: { name: 'Mexico', code: 'MX', callingCode: '+52' },
  FM: { name: 'Micronesia, Federated States of', code: 'FM', callingCode: '+691' },
  MD: { name: 'Moldova', code: 'MD', callingCode: '+373' },
  MC: { name: 'Monaco', code: 'MC', callingCode: '+377' },
  MN: { name: 'Mongolia', code: 'MN', callingCode: '+976' },
  ME: { name: 'Montenegro', code: 'ME', callingCode: '+382' },
  MS: { name: 'Montserrat', code: 'MS', callingCode: '+1 664' },
  MA: { name: 'Morocco', code: 'MA', callingCode: '+212' },
  MZ: { name: 'Mozambique', code: 'MZ', callingCode: '+258' },
  MM: { name: 'Myanmar', code: 'MM', callingCode: '+95' },
  NA: { name: 'Namibia', code: 'NA', callingCode: '+264' },
  NR: { name: 'Nauru', code: 'NR', callingCode: '+674' },
  NP: { name: 'Nepal', code: 'NP', callingCode: '+977' },
  NL: { name: 'Netherlands', code: 'NL', callingCode: '+31' },
  AN: { name: 'Netherlands Antilles', code: 'AN', callingCode: '+599' },
  NC: { name: 'New Caledonia', code: 'NC', callingCode: '+687' },
  NZ: { name: 'New Zealand', code: 'NZ', callingCode: '+64' },
  NI: { name: 'Nicaragua', code: 'NI', callingCode: '+505' },
  NE: { name: 'Niger', code: 'NE', callingCode: '+227' },
  NG: { name: 'Nigeria', code: 'NG', callingCode: '+234' },
  NU: { name: 'Niue', code: 'NU', callingCode: '+683' },
  NF: { name: 'Norfolk Island', code: 'NF', callingCode: '+672 3' },
  MP: { name: 'Northern Mariana Islands', code: 'MP', callingCode: '+1 670' },
  KP: { name: 'North Korea', code: 'KP', callingCode: '+850' },
  NO: { name: 'Norway', code: 'NO', callingCode: '+47' },
  OM: { name: 'Oman', code: 'OM', callingCode: '+968' },
  PK: { name: 'Pakistan', code: 'PK', callingCode: '+92' },
  PW: { name: 'Palau', code: 'PW', callingCode: '+680' },
  PS: { name: 'Palestine, State of', code: 'PS', callingCode: '+970' },
  PA: { name: 'Panama', code: 'PA', callingCode: '+507' },
  PG: { name: 'Papua New Guinea', code: 'PG', callingCode: '+675' },
  PY: { name: 'Paraguay', code: 'PY', callingCode: '+595' },
  PE: { name: 'Peru', code: 'PE', callingCode: '+51' },
  PH: { name: 'Philippines', code: 'PH', callingCode: '+63' },
  PN: { name: 'Pitcairn', code: 'PN', callingCode: '+64' },
  PL: { name: 'Poland', code: 'PL', callingCode: '+48' },
  PT: { name: 'Portugal', code: 'PT', callingCode: '+351' },
  PR: { name: 'Puerto Rico', code: 'PR', callingCode: '+1' },
  QA: { name: 'Qatar', code: 'QA', callingCode: '+974' },
  RE: { name: 'Reunion', code: 'RE', callingCode: '+262' },
  RO: { name: 'Romania', code: 'RO', callingCode: '+40' },
  RU: { name: 'Russia', code: 'RU', callingCode: '+7' },
  RW: { name: 'Rwanda', code: 'RW', callingCode: '+250' },
  SH: { name: 'Saint Helena', code: 'SH', callingCode: '+290' },
  KN: { name: 'Saint Kitts and Nevis', code: 'KN', callingCode: '+1 869' },
  LC: { name: 'Saint Lucia', code: 'LC', callingCode: '+1 758' },
  PM: { name: 'Saint Pierre and Miquelon', code: 'PM', callingCode: '+508' },
  VC: { name: 'Saint Vincent and the Grenadines', code: 'VC', callingCode: '+1 784' },
  WS: { name: 'Samoa', code: 'WS', callingCode: '+685' },
  SM: { name: 'San Marino', code: 'SM', callingCode: '+378' },
  ST: { name: 'Sao Tome and Principe', code: 'ST', callingCode: '+239' },
  SA: { name: 'Saudi Arabia', code: 'SA', callingCode: '+966' },
  SN: { name: 'Senegal', code: 'SN', callingCode: '+221' },
  RS: { name: 'Serbia', code: 'RS', callingCode: '+381' },
  SC: { name: 'Seychelles', code: 'SC', callingCode: '+248' },
  SL: { name: 'Sierra Leone', code: 'SL', callingCode: '+232' },
  SG: { name: 'Singapore', code: 'SG', callingCode: '+65' },
  SX: { name: 'Sint Maarten (Dutch)', code: 'SX', callingCode: '+1' },
  SK: { name: 'Slovakia', code: 'SK', callingCode: '+421' },
  SI: { name: 'Slovenia', code: 'SI', callingCode: '+386' },
  SB: { name: 'Solomon Islands', code: 'SB', callingCode: '+677' },
  SO: { name: 'Somalia', code: 'SO', callingCode: '+252' },
  ZA: { name: 'South Africa', code: 'ZA', callingCode: '+27' },
  GS: { name: 'South Georgia and the South Sandwich Islands', code: 'GS', callingCode: '+500' },
  KR: { name: 'South Korea', code: 'KR', callingCode: '+82' },
  SS: { name: 'South Sudan', code: 'SS', callingCode: '+211' },
  ES: { name: 'Spain', code: 'ES', callingCode: '+34' },
  LK: { name: 'Sri Lanka', code: 'LK', callingCode: '+94' },
  SD: { name: 'Sudan', code: 'SD', callingCode: '+249' },
  SR: { name: 'Suriname', code: 'SR', callingCode: '+597' },
  SJ: { name: 'Svalbard', code: 'SJ', callingCode: '+47' },
  SZ: { name: 'Swaziland', code: 'SZ', callingCode: '+268' },
  SE: { name: 'Sweden', code: 'SE', callingCode: '+46' },
  CH: { name: 'Switzerland', code: 'CH', callingCode: '+41' },
  SY: { name: 'Syria', code: 'SY', callingCode: '+963' },
  TW: { name: 'Taiwan', code: 'TW', callingCode: '+886' },
  TJ: { name: 'Tajikistan', code: 'TJ', callingCode: '+992' },
  TZ: { name: 'Tanzania', code: 'TZ', callingCode: '+255' },
  TH: { name: 'Thailand', code: 'TH', callingCode: '+66' },
  TG: { name: 'Togo', code: 'TG', callingCode: '+228' },
  TK: { name: 'Tokelau', code: 'TK', callingCode: '+690' },
  TO: { name: 'Tonga', code: 'TO', callingCode: '+676' },
  TT: { name: 'Trinidad and Tobago', code: 'TT', callingCode: '+1 868' },
  TN: { name: 'Tunisia', code: 'TN', callingCode: '+216' },
  TR: { name: 'Turkey', code: 'TR', callingCode: '+90' },
  TM: { name: 'Turkmenistan', code: 'TM', callingCode: '+993' },
  TC: { name: 'Turks and Caicos Islands', code: 'TC', callingCode: '+1 649' },
  TV: { name: 'Tuvalu', code: 'TV', callingCode: '+688' },
  UG: { name: 'Uganda', code: 'UG', callingCode: '+256' },
  UA: { name: 'Ukraine', code: 'UA', callingCode: '+380' },
  AE: { name: 'United Arab Emirates', code: 'AE', callingCode: '+971' },
  GB: { name: 'United Kingdom', code: 'GB', callingCode: '+44' },
  US: { name: 'United States', code: 'US', callingCode: '+1' },
  UM: { name: 'United States Minor Outlying Islands', code: 'UM', callingCode: '+1' },
  UY: { name: 'Uruguay', code: 'UY', callingCode: '+598' },
  UZ: { name: 'Uzbekistan', code: 'UZ', callingCode: '+998' },
  VU: { name: 'Vanuatu', code: 'VU', callingCode: '+678' },
  VA: { name: 'Vatican City State', code: 'VA', callingCode: '+379' },
  VE: { name: 'Venezuela', code: 'VE', callingCode: '+58' },
  VN: { name: 'Vietnam', code: 'VN', callingCode: '+84' },
  VG: { name: 'Virgin Islands, British', code: 'VG', callingCode: '+1' },
  VI: { name: 'Virgin Islands, US', code: 'VI', callingCode: '+1' },
  WF: { name: 'Wallis and Futuna', code: 'WF', callingCode: '+681' },
  EH: { name: 'Western Sahara', code: 'EH', callingCode: '+212' },
  YE: { name: 'Yemen', code: 'YE', callingCode: '+967' },
  ZM: { name: 'Zambia', code: 'ZM', callingCode: '+260' },
  ZW: { name: 'Zimbabwe', code: 'ZW', callingCode: '+263' },
};

const countriesMapForSmsRegistration = {
  AS: { name: 'American Samoa', code: 'AS', callingCode: '+1 684' },
  CA: { name: 'Canada', code: 'CA', callingCode: '+1' },
  GU: { name: 'Guam', code: 'GU', callingCode: '+1 671' },
  MP: { name: 'Northern Mariana Islands', code: 'MP', callingCode: '+1 670' },
  PR: { name: 'Puerto Rico', code: 'PR', callingCode: '+1' },
  US: { name: 'United States', code: 'US', callingCode: '+1' },
  UM: { name: 'United States Minor Outlying Islands', code: 'UM', callingCode: '+1' },
  VI: { name: 'Virgin Islands, US', code: 'VI', callingCode: '+1' },
}

export {
  countriesMap,
  countriesMapForSmsRegistration
};